import { type CurrencyCodeType } from '@mint-lib/currencies-helpers';
import { useFormattedCurrencyInput } from '@mint-lib/formatting-hooks';
import { Input, type InputProps } from '@mint-lib/tw-components';

type CurrencyInputProps = Omit<InputProps, 'value' | 'onChange'> & {
  currency: CurrencyCodeType;
  value: number | null;
  onChange: (value: number | null) => void;
};

export const CurrencyInput = ({
  value,
  currency,
  onChange,
  color,
  size,
  ...restProps
}: CurrencyInputProps) => {
  const inputProps = useFormattedCurrencyInput({
    ...restProps,
    color: color ?? undefined,
    size: size ?? undefined,
    value: value,
    currency,
    onChange,
  });

  return <Input {...inputProps} />;
};
